import { Accordion } from "@/components/ui/accordion";
import { ROUTES } from "@/constants/routes";
import { FilesRailChatContextBody } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/files/FilesRailContextSection";
import { RailGroup } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/RailGroup";
import { ChatRowDropZone } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/workspaces/WorkspacesRailChatNode";
import { MessagesSquare } from "lucide-react";
import { useMatch } from "react-router-dom";

/**
 * The contextual rail for the open workspace chat (it replaced the standalone
 * all-chats rail) — the chat analog of [`CanvasRail`], deliberately simpler:
 * just the chat's contents (its file records), with the whole group accepting
 * file drops (copy into the chat's scope). Mounted only while
 * `activeRail === "chat"`, which only exists on the workspace-chat route (the
 * header appends the tab there; SidebarContext snaps back to Workspaces on
 * leave).
 */
export function ChatsRail() {
  const chatMatch = useMatch(ROUTES.CHAT.DETAIL);
  const flowSessionId = chatMatch?.params?.flowSessionId ?? "";

  if (!flowSessionId) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center px-4 py-8">
        <p className="text-center text-sm text-n-40">
          Open a chat to see its contents here.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-2 py-2">
      <Accordion
        type="multiple"
        defaultValue={["chat-contents"]}
        className="flex flex-col"
      >
        {/* The whole contents group adds a dropped file to this chat (copy into
            its scope) — same dispatch as the chat page surface, distinct
            droppable id so the two never collide. */}
        <ChatRowDropZone flowSessionId={flowSessionId}>
          <RailGroup
            groupId="chat-contents"
            label="Chat Contents"
            icon={MessagesSquare}
            noCap
            items={[
              <FilesRailChatContextBody
                key="chat-contents-body"
                flowSessionId={flowSessionId}
              />,
            ]}
          />
        </ChatRowDropZone>
      </Accordion>
    </div>
  );
}
